import { create } from "zustand";

interface ModalState {
  isPauseSubscriptionModalOpen: boolean;
  openPauseSubscriptionModal: () => void;
  closePauseSubscriptionModal: () => void;
}

export const usePauseSubscriptionModalStore = create<ModalState>((set) => ({
  isPauseSubscriptionModalOpen: false,
  openPauseSubscriptionModal: () => set({ isPauseSubscriptionModalOpen: true }),
  closePauseSubscriptionModal: () =>
    set({ isPauseSubscriptionModalOpen: false }),
}));
